import {
    GET_INVOICE_REPORT,
    GET_INVOICE_AGING_REPORT,
    GET_INTEREST_REPORT,
    GET_RECEIPT_REPORT,
    GET_CD_NOTE_REPORT,
    GET_GST_REPORT,
    GET_RECONCILIATION_REPORT,
} from '../../index.types';

export function getInvoiceReport(data) {
    return {
        type: GET_INVOICE_REPORT,
        data
    }
}

export function getInvoiceAgingReport(data) {
    return {
        type: GET_INVOICE_AGING_REPORT,
        data
    }
}

export function getInterestReport(data) {
    return {
        type: GET_INTEREST_REPORT,
        data
    }
}

export function getReceiptReport(data) {
    return {
        type: GET_RECEIPT_REPORT,
        data
    }
}

export function getCDNoteReport(data) {
    return {
        type: GET_CD_NOTE_REPORT,
        data
    }
}

export function getGSTReport(data) {
    return {
        type: GET_GST_REPORT,
        data
    }
}

export function getReconciliationReport(data) {
    return {
        type: GET_RECONCILIATION_REPORT,
        data
    }
}
